import React from "react";
import { useState } from "react";
// import { useSelector } from "react-redux";
import "./Women.css";
import { Link } from "react-router-dom";

function Women() {
  // const womenData = useSelector((state) => state.setData)[2];
  const womenData = JSON.parse(localStorage.getItem("list"))[2];
  const womenBrands = womenData.children.slice(0, 100);

  const [search, setSearch] = useState("");
  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  return (
    <div className="container women-brands-parent">
      <div className="search text-end">
        <input
          className="search-box"
          type="text"
          placeholder="Search"
          onChange={handleChange}
        />
        <i className="fas fa-search"></i>
      </div>
      <h3 className="text-center">Women's Brands</h3>
      <div className="row women-brands">
        {womenBrands
          .filter((brand) => {
            if (
              brand.content.title.toLowerCase().includes(search.toLowerCase())
            ) {
              return brand;
            } else {
              return null;
            }
          })
          .map((brand) => (
            <Link
              key={brand.link.categoryId}
              className="col-lg-2 col-sm-3 col-3"
              to={`/products/${brand.link.categoryId}`}
            >
              <div>
                <h4>{brand.content.title}</h4>
              </div>
            </Link>
          ))}
      </div>
    </div>
  );
}

export default Women;
